import {
	Button,
	Callout,
	Icon,
	Intent,
	Tag,
} from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import React from "react";
import styled, { css } from "styled-components";

import { FlexJustify } from "common/fragments/Flex";
import BrowserUtil from "core/util/BrowserUtil";
import ConfigUtil from "core/util/config/ConfigUtil";
import { currentMode, Mode } from "core/util/Mode";
import TokenSession from "core/util/session/TokenSession";
import moment from "moment";

const StatsContainer = styled.div<{padding: boolean}>(({padding}) => css`
	${padding && css`
		padding: 15px;
	`};
	min-width: 420px;

	& .bp3-callout {
		margin-bottom: 15px;
	}

	& .heading {
		font-size: 16px;
		font-weight: bold;
		margin: 15px 0;
		display: block;
		color: inherit;
		padding: 0;
	}

	.center {
		display: flex;
		align-items: center;

		& > *:first-child {
			margin-right: 10px;
		}
	}

	.time {
		font-weight: bold;
	}

	.bp3-tag, .bp3-heading {
		text-transform: capitalize;
	}
`);

const Row = styled(FlexJustify)`
	margin-bottom: 10px;

	&:last-child {
		margin-bottom: 0;
	}
`;

interface IBuildMeta {
	revision: string;
	buildDate: number;
}

export default class SystemInfo extends React.Component<{padding?: boolean}, { meta: IBuildMeta, currentTime: number }> {
	private interval;

	constructor(props) {
		super(props);
		this.state = {meta: {revision: "n/a", buildDate: 0}, currentTime: Date.now()};
	}

	public componentDidMount() {
		if(typeof process.env.BUILD_META === "object") {
			this.setState({meta: process.env.BUILD_META});
		}

		this.interval = setInterval(() => this.setState({ currentTime: Date.now() }), 1000);
	}

	public componentWillUnmount() {
		clearInterval(this.interval);
	}

	public render() {
		const { padding = true } = this.props;
		const { meta, currentTime } = this.state;

		const built = moment(meta.buildDate);
		const start = moment(TokenSession.getEstablished());
		const end = moment(currentTime);
		const diff = end.diff(start);
		const duration = moment.utc(diff);

		return (
			<StatsContainer padding={padding}>
				<Callout intent={Intent.PRIMARY} icon={IconNames.USER}>
					<FlexJustify>
						<div>
							<h4 className="bp3-heading">{TokenSession.getUser().getName()}</h4>
							Session time <span className="time">{duration.format("HH[h ]mm[m ]ss[s]")}</span>
						</div>
						<Button
							rightIcon={IconNames.CLIPBOARD}
							minimal={true}
							intent={Intent.PRIMARY}
							onClick={() => BrowserUtil.copyToClipboard(TokenSession.getToken())}
						>
							Copy Token
						</Button>
					</FlexJustify>
				</Callout>

				<FlexJustify>
					<div className="center">
						<div>App mode</div>
						<Tag intent={Intent.NONE}>{currentMode.getName()}</Tag>
					</div>
					<div className="center">
						<div>Environnement</div>
						<Tag intent={Intent.NONE}>
							{ConfigUtil.getEnvName()}
						</Tag>
					</div>
				</FlexJustify>

				<div className="heading" />

				<Row>
					<div className="center">
						<Icon icon={IconNames.HISTORY} />
						Date built
					</div>
					<div>
						{built.format("L LT")}
					</div>
				</Row>
				<Row>
					<div className="center">
						<Icon icon={IconNames.GIT_COMMIT} />
						Commit hash
					</div>
					<div>
						<code className="bp3-code">{meta.revision}</code>
					</div>
				</Row>
			</StatsContainer>
		);
	}
}



// WEBPACK FOOTER //
// ./src/core/components/editor/SystemInfo.tsx